import { Component, OnInit, OnDestroy, ViewChildren, QueryList } from "@angular/core";
import { IContractFilter } from "@edp-components/edp-contract/edp-contract.model";
import { Store } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { Subscription } from "rxjs";
import { contractsGetFilters } from "@edp-store/selectors/contract.selectors";
import { SetContractFilters } from "@edp-store/actions/contract.actions";
import { EdpContractListFilterContentComponent } from "./edp-contract-list-filter-content/edp-contract-list-filter-content.component";
import { AppBannerService } from "@edp-services/app-banner.service";

@Component({
    selector: "edp-contract-list-filter",
    templateUrl: "./edp-contract-list-filter.component.html",
    styleUrls: ["./edp-contract-list-filter.component.scss"],
})
export class EdpContractListFilterComponent implements OnInit, OnDestroy {
    @ViewChildren("filterContent") filterContents!: QueryList<EdpContractListFilterContentComponent>;
    public filters: IContractFilter[] = [];
    public tempFiltersInfo: IContractFilter[] = [];
    public showAppBanner = false;
    private subscription = new Subscription();

    constructor(private store: Store<IAppState>, private readonly appBannerService: AppBannerService) {
        this.showAppBanner = this.appBannerService.show();
    }

    ngOnInit() {
        this.subscription = this.store.select(contractsGetFilters).subscribe((getFilters: IContractFilter[]) => {
            if (getFilters.length > 0) {
                this.filters = getFilters;
                this.tempFiltersInfo = JSON.parse(JSON.stringify(getFilters));
            }
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public applyFilter(filter: IContractFilter[]) {
        filter.forEach(flt => {
            const itemIndex = this.tempFiltersInfo.findIndex(item => item.id === flt.id);
            this.tempFiltersInfo[itemIndex] = flt;
        });
        this.store.dispatch(new SetContractFilters(this.tempFiltersInfo));
    }

    public clearFilters() {
        if (this.filterContents.toArray().length > 0) {
            this.filterContents.toArray().forEach(flt => flt.resetFilter());
        }
    }
}
